// extracted by mini-css-extract-plugin
export default {"inputContainer":"PersonalTab_inputContainer__Wo66j","nextStepBtn":"PersonalTab_nextStepBtn__dJa8H"};